<template>
  <div class="box">
    <div class="confirmDetail px-2" v-loading="confirmLoading">
      <el-input
        class="input-search"
        placeholder="请输入姓名/部门"
        clearable
        prefix-icon="el-icon-search"
        v-model="searchValue"
        @change="searchChange">
      </el-input>
      <div class="total-people">共：{{ people }}人</div>
      <div class="detail-list">
        <div class="detail-item" v-for="(list, index) in detailList" :key="index">
          <div class="item-icon">
            <img :src="list.imgUrl" alt="">
          </div>
          <div class="item-info">
            <div class="item-info-top">
              <span class="left">{{ list.name }}</span>
              <span class="right"> {{ list.emprank1 }}</span>
            </div>
            <div class="item-info-bottom">
              <span class="text">{{ list.dept }}</span>
            </div>
          </div>
          <div class="item-info-btn">
            <el-button v-if="list.isConfirm == 1" class="confirm">已确认</el-button>
            <el-button v-else class="noConfirm">未确认</el-button>
          </div>
        </div>
      </div>
      <div class="btn">
        <el-button @click="sendHolidayMsg">再次推送</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/apis'
export default {
  data() {
    return {
      confirmLoading: false,
      searchValue: '',
      people: 0,
      detailList: [],
    };
  },
  mounted(){
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.confirmLoading = true
      if (this.$route.query.flag == 'KQ') {
        // 考勤通知统计
        api.selectWorkConfirmDetaills({
          month: this.$route.query.month,
          name: this.searchValue,
        }).then((res) => {
          if (res.code == 200) {
            this.confirmLoading = false
            this.people = res.data.length
            this.detailList = res.data
          }
        }).catch(() => {
          this.confirmLoading = false
        })
      } else if (this.$route.query.flag == 'XJ') {
        // 调休/年假到期统计
        api.selectHolidayConfirmDetaills({
          month: this.$route.query.month,
          name: this.searchValue,
        }).then((res) => {
          if (res.code == 200) {
            this.confirmLoading = false
            this.people = res.data.length
            this.detailList = res.data
          }
        }).catch(() => {
          this.confirmLoading = false
        })
      }
    },
    //搜索
    searchChange() {
      this.getDataList()
    },
    //再次推送
    sendHolidayMsg() {
      const empnoList = []
      this.detailList.map((item) => {
        if (item.isConfirm == 0) {
          empnoList.push(item.empno)
        }
      })
      
      if (this.$route.query.flag == 'KQ') {
        // 考勤通知统计推送
        api.sendReport({
          empnoList: empnoList.join()
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }
        }).catch(() => {
          this.$message({
            message: '推送失败',
            type: 'error'
          });
        })
      } else if (this.$route.query.flag == 'XJ') {
        // 调休/年假到期统计推送
        api.sendHolidayMsg(empnoList).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }
        }).catch(() => {
          this.$message({
            message: '推送失败',
            type: 'error'
          });
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .confirmDetail {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .confirmDetail {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.confirmDetail {
  // @include container();
  min-height: 100vh;
  background: #fff;
  padding: 32px;
  .input-search {
    height: 60px;
    line-height: 60px;
    ::v-deep .el-input__inner {
      height: 60px;
      line-height: 60px;
      background: rgba(235, 237, 242, 0.6);
      border: none;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      // color: #BEC1C5;
      border-radius: 4px;
    }
    ::v-deep .el-icon-search {
      font-size: 24px;
      line-height: 60px;
    }
  }
  .total-people {
    margin-top: 40px;
    margin-bottom: 20px;
    font-family: PingFang-SC-Heavy, PingFang-SC;
    font-size: 28px;
    color: #4EA27C;
  }
  .detail-list {
    overflow-y: auto;
    height: calc(100vh - 450px);
    /* 隐藏滚动条 */
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .detail-item {
      display: flex;
      justify-content: space-between;
      padding: 40px 0;
      border-bottom: 1px solid #F1F1F1;
      .item-icon {
        overflow: hidden;
        width: 60px;
        height: 60px;
        margin-top: 5px;
        background: #eee;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-info {
        width: 65%;
        margin-left: 32px;
        .item-info-top {
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 44px;
          .left {
            font-size: 32px;
            color: #282B32;
            font-weight: 500;
          }
          .right {
            font-size: 24px;
            color: #969B9E;
          }
        }
        .item-info-bottom {
          .text {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #282B32;
            &::after {
              content: ' | ';
            }
            &:last-child {
              &::after {
                content: ' | ';
                display: none;
              }
            }
          }
        }
      }
      .item-info-btn {
        margin-top: 20px;
        .el-button {
          border: none;
          border-radius: 8px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #FFFFFF;
          text-align: center;
        }
        .confirm {
          background: #05B775;
        }
        .noConfirm {
          background: #F45657;
        }
      }
    }
  }
  .btn {
    margin-top: 100px;
    .el-button {
      width: 100%;
      height: 96px;
      background: #4EA27C;
      border: none;
      border-radius: 16px;
      font-size: 32px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #FFFFFF;
    }
  }
}
</style>